import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { E_Mandate } from '../../Global/Index';
import BeatLoader from 'react-spinners/BeatLoader';
import './E_Mandate.css'
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { TbSend } from 'react-icons/tb';


const serviceMap = {
  'service1': ['Create Mandate', 18],
  'service2': ['Amend Mandate', 19],
  'service3': ['Cancel Mandate', 20],
  'service4': ['Suspend/Revoke', 21],
};


const override = {
  margin: "0 auto",
  marginLeft: '.3vw'
};



const Mandate = ({ service }) => {
  const inputRef = useRef(null);
  const [submitloader, setSubmitloader] = useState(false);
  const theme = useTheme();
  // get datas from token 


  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentValue = inputRef.current.value;
    const descriptionRegex = /^[^<>{}&]*$/;
    const trimmedDescription = currentValue.trim();

    if (trimmedDescription === "") {
      toast.error("Description can't be blank");
      return;
    }

    if (currentValue.startsWith(' ')) {
      toast.error("Error: The Description must not begin with a space.");
      return;
    }

    if (!descriptionRegex.test(trimmedDescription)) {
      toast.error("Error: The Description contains invalid characters.");
      return;
    }


    setSubmitloader(true);
    const customerdetail = {
      "RecordType": serviceMap[service][1],
      "serviceName": serviceMap[service][0],
      "Description": currentValue,
    }

    if (currentValue == '') {
      toast.error('Please enter the description');
      setSubmitloader(false);
    } else {

      const resp = await E_Mandate(customerdetail)
      if (resp.response.status === "200" && resp.response.message === 'Success') {
        toast.success('Request has been successfully submitted');
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      } else if (resp.response.status === "419") {
        window.location.href = '/Session-Expired'
      } else if (resp.response.status === "500") {
        toast.error('Something went wrong. Please try again later!')
      } else if (resp.response.status === "503") {
        toast.warn(resp.response.message);
      } else if (resp.response.status == '401') {
        window.location.href = '/'
      }
      setSubmitloader(false);
    }
  };



  return (
    <div style={{ display: 'flex' }}>

      <div className='mandatecontainer'>
        <div id='container2' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <textarea type="text" ref={inputRef} placeholder='Enter Request Details' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary[100], border: 'none' }} />
          <button
            type="submit"
            onClick={handleSubmit}
            id='servicerequestsubmitbutton'
            disabled={submitloader}
            style={{
              margin: '0vw auto',
              background: theme.palette.maincolor.buttoncolor,
              color: theme.palette.maincolor.light,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}
          >
            {submitloader ? (
              <>
                <span>Processing</span>
                <BeatLoader
                  color="rgb(155,57,19)"
                  loading={submitloader}
                  cssOverride={override}
                  size={6}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </>
            ) : (
              <>
                <TbSend size={20} />
                <span>Submit</span>
              </>
            )}
          </button>
        </div>

      </div>
    </div>)

}




const EMendate = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleAccordion = (index) => {
    setActiveIndex(index);

  };
  const theme = useTheme();


  return (

    <div className="accordion">
      <div className={`accordion-item ${activeIndex === 0 ? 'active' : ''}`}>
        <button className="accordion-header" onClick={() => handleAccordion(0)} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <p>Create Mandate</p>{activeIndex != 0 ? <i className="bi bi-chevron-right" /> : null}
        </button>
        {activeIndex === 0 ? <div className="accordion-content">
          <Mandate service='service1' />
        </div> : null}

      </div>

      <div className={`accordion-item ${activeIndex === 1 ? 'active' : ''}`}>
        <button className="accordion-header" onClick={() => handleAccordion(1)} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <p>Update Mandate</p>{activeIndex != 1 ? <i className="bi bi-chevron-right" /> : null}
        </button>
        {activeIndex === 1 ? <div className="accordion-content">
          <Mandate service='service2' />
        </div> : null}
      </div>

      <div className={`accordion-item ${activeIndex === 2 ? 'active' : ''}`}>
        <button className="accordion-header" onClick={() => handleAccordion(2)} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <p>Cancel Mandate</p> {activeIndex != 2 ? <i className="bi bi-chevron-right" /> : null}
        </button>
        {activeIndex === 2 ? <div className="accordion-content">
          <Mandate service='service3' />
        </div> : null}
      </div>

      <div className={`accordion-item ${activeIndex === 3 ? 'active' : ''}`}>
        <button className="accordion-header" onClick={() => handleAccordion(3)} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <p>Revoke Mandate</p>{activeIndex != 3 ? <i className="bi bi-chevron-right" /> : null}
        </button>
        {activeIndex === 3 ? <div className="accordion-content">
          <Mandate service='service4' />
        </div> : null}
      </div>

    </div>

  )
}

// PropTypes validation
Mandate.propTypes = {
  service: PropTypes.string.isRequired,
};


export default EMendate;